import { Component, inject } from "@angular/core";
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { CdkScrollable } from "@angular/cdk/scrolling";

@Component({
  selector: "app-confirm-resource-skill-changes-dialog",
  template: `
    <div class="dialog-container">
      <h2 mat-dialog-title>Confirm Resource Skill Changes</h2>

      <div mat-dialog-content>
        <div class="warning-message">
          <mat-icon color="warn">warning</mat-icon>
          <p>
            Warning: Changes to resource skills can cause auto-booked work to be
            referred.
          </p>
          <p>Do you want to continue with saving these changes?</p>
        </div>
      </div>

      <div mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Cancel</button>
        <button mat-raised-button color="primary" (click)="confirm()">
          Confirm
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .dialog-container {
        padding: 16px;
        min-width: 400px;
      }
      .warning-message {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        margin: 16px 0;
      }
      .warning-message mat-icon {
        font-size: 48px;
        height: 48px;
        width: 48px;
        margin-bottom: 16px;
      }
      .warning-message p {
        margin: 8px 0;
      }
    `
  ],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatIcon,
    CdkScrollable
  ]
})
export class ConfirmResourceSkillChangesDialogComponent {
  dialogRef =
    inject<MatDialogRef<ConfirmResourceSkillChangesDialogComponent>>(
      MatDialogRef
    );

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
